import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Slider, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

const trackingTempToSliderValue = (theValue) => (0 - theValue) / 2;
const trackingTempFromSliderValue = (sValue) => (0 - sValue) * 2;

const markLinkStyle = {
  fontSize: 10,
  fontWeight: 500,
  padding: '2px',
};

export const DisplayTrackingTemperatureSliderItem = ({
  register,
  tc,
  icon,
  min,
  max,
  step,
  onFormat,
  onChange,
  disabled,
  borderOff,
}) => {
  const [value, setValue] = useState(trackingTempToSliderValue(register.value));

  const forMatValue = () => value + '°C';

  const updateValue = (value, event) => {
    const convertedValue = trackingTempFromSliderValue(value);
    devLog('converted from slider =', convertedValue, event, value);
    onChange(register, convertedValue);
  };

  useEffect(() => {
    const convertedValue = trackingTempToSliderValue(register.value);
    setValue(convertedValue);
    devLog('temperature value updated to :', convertedValue);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
            paddingLeft: 10,
            paddingRight: 5,
          }}
        >
          <Slider
            progress
            barClassName="slideritem"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={setValue}
            onChangeCommitted={updateValue}
            renderTooltip={forMatValue}
            disabled={disabled}
            graduated
            renderMark={(mark) => {
              if (mark % 5 === 0) {
                return <span style={markLinkStyle}>{mark}°C</span>;
              }
              return null;
            }}
          />
        </div>
      </Flex>
    </Panel>
  );
};
